import React from 'react';
import { Button, ButtonProps } from '@economic/taco';

type AcceptedFileType = 'application/pdf' | 'image/gif' | 'image/jpeg' | 'image/png' | 'text/xml';
type AcceptedFileTypes = AcceptedFileType[];

interface Props extends ButtonProps {
    onFileSelect: (files: FileList | null) => void;
    fileInputKey: number;
    appearance?: 'primary' | 'discrete' | 'default';
    acceptedFileTypes?: AcceptedFileTypes;
}

export default function FileUploadButton({
    appearance = 'primary',
    acceptedFileTypes,
    onFileSelect: handleChange,
    fileInputKey,
    ...props
}: Props) {
    const ref = React.useRef<HTMLInputElement>(null);

    return (
        <>
            <Button
                appearance={appearance}
                {...props}
                onClick={() => {
                    if (ref?.current) {
                        ref.current.click();
                    }
                }}
            />
            <input
                multiple
                accept={acceptedFileTypes?.join(', ')}
                name="files"
                onChange={event => handleChange(event.target.files)}
                ref={ref}
                type="file"
                className="hidden"
                key={fileInputKey}
            />
        </>
    );
}
